// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { Loader } from "@revvsales/components";

// Component Imports
import GlobalTemplatesList from "./GlobalTemplatesList";
import GlobalTemplatesPreview from "./GlobalTemplatesPreview";
import TemplateHeader from "../TemplateHeader";
import TemplateSearchTags from "../TemplateSearchTags/TemplateSearchTags";

// Service Imports
import {
  updateGlobalTemplates,
  clearTemplateSearchTerm,
} from "../../../actions/DocumentTemplateActions/templateActions";

// Internal Imports
import { AmplitudeUtils } from "../../../utils";
import { LOADING_MSG, EVENTS } from "../../../constants";

// Destructuring
const { amplitudeLogEvent } = AmplitudeUtils;

const GLOBAL_TEMPLATES = "global";

class GlobalTemplates extends Component {
  state = {
    isLoading: false,
    selectedDocIndex: null,
    showSearchPage: false,
    searchTemplatePreview: null,
  };

  componentDidMount() {
    amplitudeLogEvent(EVENTS.EVENT_NAMES.TEMPLATE_LIBRARY_VIEWED);
    this._loadGlobalTemplates();
  }

  _loadGlobalTemplates = () => {
    this.setState({ isLoading: true });
    const { updateGlobalTemplates: updateGlobalTemplatesAction } = this.props;
    updateGlobalTemplatesAction()
      .then(() => {
        this.setState({ isLoading: false });
      })
      .catch(err => {
        this.setState({ isLoading: false });
        console.error("GlobalTemplates => useEffect", err);
      });
  };

  _togglePreview = index => {
    const { globalTemplates } = this.props;
    if (index !== null) {
      amplitudeLogEvent(EVENTS.EVENT_NAMES.TEMPLATE_PREVIEW_CLICKED, {
        TemplateID: globalTemplates[index].id,
        TemplateName: globalTemplates[index].title,
        SequenceNumber: index + 1,
      });
    } else {
      amplitudeLogEvent(EVENTS.EVENT_NAMES.TEMPLATE_PREVIEW_CLOSED, {
        TemplateID: globalTemplates[this.state.selectedDocIndex].id,
        TemplateName: globalTemplates[this.state.selectedDocIndex].title,
        SequenceNumber: this.state.selectedDocIndex + 1,
      });
    }
    this.setState({ selectedDocIndex: index });
  };

  _toggleSearchPage = flag => {
    this.setState({ showSearchPage: flag });
    if (!flag) {
      this._loadGlobalTemplates();
    }
  };

  _toggleSearchTemplatePreview = template => {
    this.setState({
      searchTemplatePreview: template,
    });
  };

  _clearSearchTerm = () => {
    const { clearTemplateSearchTerm: clearSearchTerm } = this.props;
    this._toggleSearchPage(false);
    clearSearchTerm();
  };

  render() {
    if (this.state.isLoading) {
      return <Loader label={LOADING_MSG.TEMPLATES} />;
    }

    const {
      globalTemplates,
      searchTerm,
      templateSearchSuggestions,
    } = this.props;
    const { showSearchPage, searchTemplatePreview } = this.state;

    return (
      <div className="globaltemplates-wrapper">
        {/** HEADER SECTION */}
        <section className="templates-header">
          <TemplateHeader
            type={GLOBAL_TEMPLATES}
            showSearchPage={showSearchPage}
            toggleSearchPage={this._toggleSearchPage}
            togglePreview={this._toggleSearchTemplatePreview}
          />
        </section>
        {/** BODY SECTION */}
        {showSearchPage ? (
          <TemplateSearchTags
            searchTerm={searchTerm}
            clearSearchTerm={this._clearSearchTerm}
          />
        ) : null}
        <section className="templatebody-scrollable">
          <div className="templatedetails-table-wrapper">
            <div className="globaltemplates-list">
              {globalTemplates &&
                globalTemplates.map((item, index) => (
                  <GlobalTemplatesList
                    key={item.id}
                    data={item}
                    index={index}
                    previewOpen={this._togglePreview}
                  />
                ))}
            </div>
          </div>
        </section>

        {/* Empty Search Results */}
        {showSearchPage && globalTemplates && !globalTemplates.length ? (
          <div className="template-search-no-results">No results found</div>
        ) : null}

        {/** PREVIEW POPUP SECTION */}
        <section>
          {this.state.selectedDocIndex !== null && (
            <GlobalTemplatesPreview
              list={globalTemplates}
              index={this.state.selectedDocIndex}
              previewClose={this._togglePreview}
            />
          )}
        </section>
        {/** Search PREVIEW POPUP SECTION */}
        <section>
          {searchTemplatePreview !== null && (
            <GlobalTemplatesPreview
              list={templateSearchSuggestions}
              index={searchTemplatePreview}
              previewClose={this._toggleSearchTemplatePreview}
            />
          )}
        </section>
      </div>
    );
  }
}

const mapStateToProps = ({
  TemplateStore: { globalTemplates, searchTerm, templateSearchSuggestions },
}) => ({
  globalTemplates,
  searchTerm,
  templateSearchSuggestions,
});

const mapDispatchToProps = {
  updateGlobalTemplates,
  clearTemplateSearchTerm,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GlobalTemplates);



// WEBPACK FOOTER //
// ./src/components/TemplateV2/GlobalTemplates/index.js